// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  name: "prod",
  PleamAuthUrl: "/realms/Pleam-Rlm/protocol/openid-connect/token",
  pleamLogoutUrl: "/realms/Pleam-Rlm/protocol/openid-connect/logout",
  appIdIos:'1570609850',

  keycloakConfig: {
    "realm": "Pleam-Rlm",
    "url": "https://pleamsignin.pleam.fr/auth",
    "clientId": "PleamCl",
    "confidential-port": 0,
    "client_secret": "f9e5a1e7-8274-4f40-bfaf-7ffd166b45cc"
},
httpRequestDebugMode: true,

  firebaseConfig: {
    apiKey: "AIzaSyDHW__-Z4QVNA7PRxYLWTqC1SIzXZ1XEto",
    authDomain: "pleam-prod.firebaseapp.com",
    projectId: "pleam-prod",
    storageBucket: "pleam-prod.appspot.com",
    messagingSenderId: "959548968396",
    appId: "1:959548968396:web:5c07d234189a47e5bca169",
    measurementId: "G-M23RR295T5"

},


keycloakSmsConfig: {
  grant_type: "password",
  username: "pleamUser",
  password: "U`qvNT~B]!?_7#({",
  client_id: "hub-messages",
  //scope: 'openid',
  client_secret: "8982c5a7-cb50-47fd-8ad4-a66fab5cd5dc"
}, 
SMSAuthUrl : "https://pleamsignin.pleam.fr/auth/realms/Hub-messages/protocol/openid-connect/token",
SMSApiUrl: "https://apis.imbaconsulting.com/message"


};
export  const SERVER_URL = 'https://apis.pleam.fr';
 


 export const StripeEnvironmentSandbox = 'pk_live_51IfgqvBmXRLBI2maL7UdZDgA3o74be3IDa2XvdufUsZyEIgN06HfFrRUnz0C3Zcmro4FTj3w1MkyYrpeXHq7GVwX00OIp5KheL';
 export const devKeyAppFlayers = 'n68pMwCzG3dU8MT2EFdKGQ';
 //bcd577e5-87ee-4e2d-856d-012c0570cfc0
 export const ProducttokenSMS = '6d60944b-0bed-46eb-88ee-a456489dfc55';
 
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

